import { useEffect, useState } from 'react';
import axios from 'axios';
import { SERVER_ADDRESS } from '../../../Component/server';
import MemberSignupForm, { MemberFields, MemberSubmission } from './MemberSignupForm';

export default function AwakeSignup({ provider = 'awake' }: { provider?: 'awake' | 'kakao' }) {
  const [profile, setProfile] = useState<Partial<MemberFields>>();
  const [csrfToken, setCsrf] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    axios.get(`${SERVER_ADDRESS}user/${provider}/signup`, { withCredentials: true }).then(({ data }) => {
      if (!active) return;
      setCsrf(data.csrfToken);
      setProfile({ nickname: data.nickname || '', name: data.name || '', user_email: data.user_email || '', phone: data.phone || '' });
    }).catch(err => {
      if (active) setError(err?.response?.data?.message || '가입 정보를 불러오지 못했습니다.');
    });
    return () => { active = false; };
  }, [provider]);
  const submit = async (values: MemberSubmission) => {
    const { data } = await axios.post(`${SERVER_ADDRESS}user/${provider}/signup`, {
      ...values, csrfToken,
    }, { withCredentials: true });
    localStorage.removeItem('key'); localStorage.removeItem('authority');
    sessionStorage.removeItem('key'); sessionStorage.removeItem('authority');
    if (data.newRefreshToken) sessionStorage.setItem('key', data.newRefreshToken);
    window.location.assign(data.redirectUrl);
  };
  return <MemberSignupForm initialValues={profile} ready={!!csrfToken} error={error} onSubmit={submit} />;
}
